import journeyBuilderReducer from 'reducers/journeyBuilder';
import { configureStore } from './configureStore';

export default function createStore(initialState) {
  const store = configureStore(initialState, journeyBuilderReducer, {
    name: 'JourneyBuilder',
  });

  return store;
}
